import React from "react";

import { Button, Input, Select } from "antd";

import { DashboardType } from "models/workspace";

export interface CloneFormProps {
  title: string;
  setTitle: (title: string) => void;
  type: DashboardType;
  setType: (type: DashboardType) => void;
  /** The dashboard types the user may create in this workspace, in display order. */
  typeOptions: DashboardType[];
  isLoading: boolean;
  error: string;
  onClone: () => Promise<void>;
  onCancel: () => void;
}

export const CloneForm: React.FC<CloneFormProps> = ({
  title,
  setTitle,
  type,
  setType,
  typeOptions,
  isLoading,
  error,
  onClone,
  onCancel
}) => (
  <div className="dashboard-clone-form">
    <div className="dashboard-clone-form__header">
      <strong>Clone Dashboard</strong>
    </div>
    <div className="dashboard-clone-form__field">
      <label className="dashboard-clone-form__label">Dashboard Title</label>
      <Input
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Enter dashboard title"
        autoFocus
        onPressEnter={onClone}
      />
    </div>
    <div className="dashboard-clone-form__field dashboard-clone-form__field--type">
      <label className="dashboard-clone-form__label">Dashboard Type</label>
      <Select
        value={type}
        onChange={setType}
        className="dashboard-clone-form__select"
        // A single option is still rendered as a select so the user can see which type
        // the clone will be created as.
        options={typeOptions.map((option) => ({ label: option, value: option }))}
      />
    </div>
    {error && <div className="dashboard-clone-form__error-message">{error}</div>}
    <div className="dashboard-clone-form__actions">
      <Button size="small" onClick={onCancel} disabled={isLoading}>
        Cancel
      </Button>
      <Button size="small" type="primary" onClick={onClone} loading={isLoading}>
        Clone
      </Button>
    </div>
  </div>
);
